import { useEffect, useMemo, useState } from 'react';
import { defaultWidget } from '../constants';
import { AllTypeWidgets, DwQueryRequest } from '../types';
import { TableTypeWidget } from '../types/TableWidget.types';

const toTableViewWidget = (w: AllTypeWidgets): TableTypeWidget =>
  ({
    ...defaultWidget,
    definition: {
      ...defaultWidget.definition,
      custom: { ...defaultWidget.definition.custom, ...w.definition.custom },
    },
    requests: w.requests,
  }) as TableTypeWidget;

const useTableViewWidget = (sourceWidget: AllTypeWidgets) => {
  const [tableViewWidget, setTableViewWidget] = useState<TableTypeWidget>(() => toTableViewWidget(sourceWidget));

  const tableViewWidgetKey = useMemo(
    () =>
      JSON.stringify(
        (sourceWidget.requests as DwQueryRequest[]).map(({ select, projectionId, filter }) => ({ select, projectionId, filter }))
      ),
    [sourceWidget.requests]
  );

  useEffect(() => {
    setTableViewWidget(toTableViewWidget(sourceWidget));
  }, [tableViewWidgetKey]); // intentionally keyed on tableViewWidgetKey, not sourceWidget

  return { tableViewWidget, setTableViewWidget, tableViewWidgetKey };
};

export default useTableViewWidget;
